<input type="text" class="form-control" [name]="name" [placeholder]="placeholder" #dateRangePicker/>